/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#d3d3d3;opacity:1}[_ngcontent-%COMP%]::-moz-placeholder{color:#d3d3d3;opacity:1}[_ngcontent-%COMP%]:-ms-input-placeholder{opacity:1;color:#d3d3d3}[_ngcontent-%COMP%]::-ms-input-placeholder{opacity:1;color:#d3d3d3}[_ngcontent-%COMP%]::placeholder{color:#d3d3d3;opacity:1}"];
export { styles as styles };
